import type { UiStatusType } from '@/types';

export const UI_STATUS_TYPE = {
  DataManagementTutorial: 'DataManagementTutorial',
} as const satisfies Record<string, UiStatusType>;
